import { useAuth } from "../../store/AuthContext";
import { useWorkspace } from "../../store/WorkspaceContext";
import { useAdminNew } from "../../hooks/useAdminNew";

const Tab = ({ id, onClick, className, title, children }) => (
  <button data-testid={id} onClick={onClick} title={title} className={`mr-1 flex flex-shrink-0 items-center gap-1.5 rounded-md border px-2.5 py-1 text-[12px] font-semibold transition-colors ${className}`}>{children}</button>
);

export const PlanTabs = () => {
  const { user } = useAuth();
  const { dispatch } = useWorkspace();
  const fresh = useAdminNew(user?.role === "admin");
  if (!user) return null;
  const open = (dialog) => dispatch({ type: "SET", patch: { dialog } });
  if (user.role === "admin") {
    return (
      <Tab id="plan-tab-owner" onClick={() => open("admin")} title={fresh ? `${fresh} new since you last looked · opens the Owner dashboard` : "Owner account · unlimited · opens the Owner dashboard"} className="relative border-[#e8e9ec]/30 bg-[#e8e9ec]/10 text-[#e8e9ec] hover:bg-[#e8e9ec]/20">
        Taji- Owner
        {fresh > 0 && <span data-testid="owner-new-badge" className="absolute -right-1.5 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-[#e5484d] px-1 font-mono text-[9.5px] font-bold text-white shadow-[0_0_8px_rgba(229,72,77,.7)]">{fresh}</span>}
      </Tab>
    );
  }
  // Customers manage their plan from My Dashboard (name button); no plan tabs in the toolbar.
  return null;
};
